import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Workflow } from "components";
import { useTheme } from "contexts";
import { Helpers } from "utils";

type Props = {};

export const UserContributor = (props: Props) => {
  const { theme } = useTheme();

  return (
    <Box pt={theme.spacing.sm}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Common.Image src={Helpers.getImage("homepage_banner.png")} />
              <Workflow.Flows.ContributorWrapper />
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{
                top: 0,
                display: { xs: "none", md: "flex" },
                height: "100vh", // Ensures it takes up full height
                position: "sticky",
                overflow: "hidden", // Prevents internal scrolling
                alignItems: "center", // Centers image if needed
                justifyContent: "center",
              }}
            >
              <Common.Image src={Helpers.getImage("homepage_art.png")} />
            </Grid>
          </Grid>
        </Container>
        <Common.Footnote />
      </Stack>
    </Box>
  );
};
